import { render, staticRenderFns } from "./CollapsableSideBar.vue?vue&type=template&id=49cadc82&scoped=true&"
import script from "./CollapsableSideBar.vue?vue&type=script&lang=js&"
export * from "./CollapsableSideBar.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableSideBar.vue?vue&type=style&index=0&id=49cadc82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cadc82",
  null
  
)

export default component.exports